import React, { useRef } from 'react';
import {
  CommunityBusinessHeroBannerContent,
  CommunityBusinessHeroBannerContainer,
} from './CommunityBusinessHeroStatic.styles';
import LogoShowcaseAutoScroll from 'src/molecules/Standard/Shared/LogoShowcaseAutoScroll/LogoShowcaseAutoScroll';
import HeroScreenSwap from 'src/molecules/Standard/Shared/2024_Q3_profit_sales_redesign/HeroScreenSwap/HeroScreenSwap';
import HeroWordTypeIn from 'src/molecules/Standard/Homepage/2024_Q4/HeroWordTypeIn/HeroWordTypeIn';

const CommunityBusinessHeroStatic = (): JSX.Element => {
  const containerRailRef = useRef<HTMLDivElement>(null);

  return (
    <CommunityBusinessHeroBannerContainer ref={containerRailRef}>
      <CommunityBusinessHeroBannerContent>
        <HeroWordTypeIn heroMainHeadline={`The community platform for `} />
        <HeroScreenSwap />
        <LogoShowcaseAutoScroll />
      </CommunityBusinessHeroBannerContent>
    </CommunityBusinessHeroBannerContainer>
  );
};

export default CommunityBusinessHeroStatic;
